import React from "react";
import "./Header.scss";
import images from "../../../../utilities/images/images";
import { useHistory } from "react-router-dom";

const Header = ({ paperName,onBack,backPath }) => {
  // const navigate = useHistory();
  // const handleBackClick = () => {
  //   navigate.push("/TestInstruction");
 const history = useHistory();

  const handleBackClick = () => {
    if (onBack) {
      onBack();            
    } else if (backPath) {
      history.push(backPath);  
    } else {
      history.goBack();  
    }
  };

  return (
    <div className="analytics__header">
      <div
        className="analytics__header__left"
        onClick={handleBackClick}
        style={{ cursor: "pointer" }}
      >
        <img src={images.backBtn} alt="backbtn" />
        <div>{paperName}</div>
      </div>

      <div className="analytics__header__right">Analytics</div>
    </div>
  );
};

export default Header;
